import config from '../config';
import mapboxgl from 'mapbox-gl';
import mapPopUpTable from './mapPopUpTable';

// these layers are added in a specific order. whatever gets added last gets painted on top of what is already there
export default function addVectorTiles(
  map,
  mapType,
  stateSchema,
  cogTileServStateData
) {
  if (!['area', 'zoom'].includes(mapType)) {
    throw new Error("Illegal mapType. Must be either 'area' or 'zoom'.");
  }

  map.addSource('3dep-wms-source', {
    type: 'raster',
    tiles: [
      'https://elevation.nationalmap.gov/arcgis/rest/services/3DEPElevation/ImageServer/exportImage?bbox={bbox-epsg-3857}&bboxSR=3857&size=&imageSR=3857&time=&format=png&pixelType=F32&noData=&noDataInterpretation=esriNoDataMatchAny&interpolation=+RSP_BilinearInterpolation&compression=&compressionQuality=&bandIds=&mosaicRule=&renderingRule=&f=image'
    ],
    tileSize: 256
  });

  map.addLayer({
    id: '3DEP Elevation',
    type: 'raster',
    source: '3dep-wms-source',
    paint: {},
    layout: { visibility: 'none' } // start with all layers turned off
  });

  if (cogTileServStateData) {
    map.addSource('Model Elevation', {
      type: 'raster',
      tiles: [cogTileServStateData.URL],
      minzoom: 7,
      maxzoom: 16,
      bounds: cogTileServStateData.bounds,
      tileSize: 512
    });

    map.addLayer({
      id: 'Model Elevation',
      type: 'raster',
      source: 'Model Elevation',
      paint: {},
      layout: { visibility: 'none' } // start with all layers turned off
    });
  }

  if (mapType === 'area') {
    map.addSource('counties', {
      type: 'vector',
      url: 'mapbox://ravitheja.9jeptzwy'
    });

    map.addLayer({
      id: 'Counties',
      source: 'counties',
      'source-layer': 'counties-70y5bd',
      type: 'line',
      paint: {
        'line-color': '#877b59',
        'line-width': 1
      },
      layout: { visibility: 'none' } // start with all layers turned off
    });
  }

  if (mapType === 'area') {
    map.addSource('states', {
      type: 'vector',
      url: 'mapbox://ravitheja.b7sio8e7'
    });

    map.addLayer({
      id: 'States',
      source: 'states',
      'source-layer': 'states_gz_2010_us_040_00_20m',
      type: 'line',

      paint: {
        'line-color': '#000000',
        'line-width': 2
      },
      layout: { visibility: 'none' } // start with all layers turned off
    });
  }

  map.addSource('nhdplus_flowline_network', {
    type: 'vector',
    tiles: [
      'https://s3.amazonaws.com/dewberry-demo/model_inventory-vector-tiles/nhdplus_flowline_network/{z}/{x}/{y}.pbf'
    ],
    minzoom: 1,
    maxzoom: 20
  });

  map.addLayer({
    id: 'NHD Flowlines',
    source: 'nhdplus_flowline_network',
    'source-layer': 'nhdplus_flowline_network',
    type: 'line',
    paint: {
      'line-color': '#14e390',
      'line-width': {
        base: 1, // base size
        stops: [
          // allows feature to change size with zoom level
          [7, 1], // at zoom 0, we want size 1
          [16, 5], // that scales to zoom 20, where we want size 5
          [20, 5]
        ]
      },
      'line-opacity': 0.5
    },
    layout: { visibility: 'none' } // start with all layers turned off
  });

  if (mapType === 'area') {
    map.addSource('tide_stations', {
      type: 'vector',
      tiles: [config.stateAssetsTileService(stateSchema, 'tide_stations')],
      minzoom: 1,
      maxzoom: 20
    });

    map.addLayer({
      id: 'Tide Stations',
      source: 'tide_stations',
      'source-layer': `${stateSchema}.tide_stations`,
      type: 'circle',
      paint: {
        'circle-radius': 10,
        'circle-color': '#007cbf',
        'circle-opacity': 0.5,
        'circle-stroke-width': 0
      },
      layout: { visibility: 'none' } // start with all layers turned off
    });

    map.on('click', 'tide_stations', function (e) {
      new mapboxgl.Popup()
        .setLngLat(e.lngLat)
        .setHTML(mapPopUpTable(e.features[0]))
        .addTo(map);
    });

    map.on('mouseenter', 'tide_stations', () => {
      map.getCanvas().style.cursor = 'pointer';
    });

    // Change it back to a pointer when it leaves.
    map.on('mouseleave', 'tide_stations', () => {
      map.getCanvas().style.cursor = '';
    });
  }
}
